import React, { useState } from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import AccountCircle from "@material-ui/icons/AccountCircle";
import TextField from "@material-ui/core/TextField";

import "./styles.css";
import { Button, InputAdornment } from "@material-ui/core";
import { BASE_URL, postLogin } from "../../Models/Fetcher";
import { useSetRecoilState } from "recoil";
import { loggedUserState } from "../../Store/atoms";
import { Link } from "react-router-dom";
import VpnKeyIcon from "@material-ui/icons/VpnKey";

const useStyles = makeStyles({
  loginButton: {
    background: "linear-gradient(45deg, #292961, #1c2321)",
    color: "white",
    fontSize: "1.3rem",
    marginTop: "4rem",
  },

  loginInput: {
    margin: "1.3rem 0",
    fontSize: "5rem",
  },
});

export default () => {
  const classes = useStyles();
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const setLoggedUser = useSetRecoilState(loggedUserState);
  const [error, setError] = useState(false);

  const handlePswdChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    const value = e.target.value as string;
    setPassword(value);
  };

  const handleUsrChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    const value = e.target.value as string;
    setUsername(value);
  };

  const handleSubmit = async () => {
    const user = await postLogin(BASE_URL + "login", {
      name: username,
      password: password,
    });

    if (!user || user.status !== 200) {
      // TODO: wrong login handling
      setError(true);
    } else {
      setError(false);
      setLoggedUser({ id: user.data.id, token: user.data.token });
      localStorage.setItem("jwt", user.data.token);
      localStorage.setItem("userId", user.data.id.toString());
    }
  };

  return (
    <div className="login-page">
      <div className="form-container">
        <h1 className="login-header">Login</h1>
        <form className="login__form" noValidate autoComplete="off">
          <TextField
            className={classes.loginInput}
            id="login-name"
            label="Username"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
            placeholder="Type your name"
            size="medium"
            onChange={handleUsrChange}
          />
          <TextField
            className={classes.loginInput}
            id="login-password"
            label="Password"
            placeholder="Type your password"
            size="medium"
            onChange={handlePswdChange}
            type="password"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <VpnKeyIcon />
                </InputAdornment>
              ),
            }}
          />

          {error && (
            <div className="login-error">
              Login unsuccesfull, please try again
            </div>
          )}

          <Button
            className={classes.loginButton}
            onClick={handleSubmit}
            variant="contained"
          >
            LOGIN
          </Button>
          <Link className="signup__button" to="/signup">
            <Button>SIGN UP</Button>
          </Link>
        </form>
      </div>
    </div>
  );
};
